<template>
  <div class="header-content">
    <img class="header-img" src="@/assets/page1-bg.png">
    <img class="header-phone" src="@/assets/page1-bg-phone.png">
    <img class="logo" src="@/assets/logo.png" alt="logo">
    <div class="title-bg"></div>
    <!-- <div class="title-text">Ninja: Chakra Warriors</div> -->
    <div class="title-text">Наследие ниндзя: Надежда</div>
    <div class="content">
      <div class="content-wrapper">
        <p>В этом фантастическом мире легенды о ниндзя никогда не угасали. Неожиданный кризис разрушил спокойствие мира шиноби. Злые силы вновь подняли голову, пытаясь поглотить весь мир. Ты превратишься в ниндзя с мечтой и миссией, возьмёшь на себя тяжёлую ответственность по спасению мира и отправишься в захватывающее дух приключение.</p>
        <p>В игре представлено множество персонажей-ниндзя на выбор и для прокачки. У каждого ниндзя уникальные навыки и таланты. Ты можешь собрать свою идеальную команду ниндзя в соответствии со стилем боя и стратегическими потребностями. В то же время тебе предстоит использовать различные техники ниндзя и стратегии для ожесточённых битв со злыми силами.</p>
        <p>**Разнообразные персонажи-ниндзя в разных стилях, каждый с уникальным набором навыков и историей, чтобы удовлетворить предпочтения разных игроков.**</p>
        <p>**Крутые спецэффекты техник ниндзя, позволяющие ощутить острые ощущения от боя и визуальный праздник во время сражений.**</p>
        <p>**Постоянно повышай силу своих ниндзя, строй свою самую мощную команду, и только грамотно расставляя ниндзя в составе, ты сможешь победить сильных врагов**</p>
      </div>
    </div>
  </div>
</template>
<script>
import config from "../config.js";
export default {
  data() {
    return {
      config,
    }
  }
}
</script>
<style lang="scss" scoped>
.header-content{
  position: relative;
  .header-img{
    width: 100%;
    // height: 1080px;
  }
  .logo{
    position: absolute;
    top: 20px;
    left: 100px;
    width: 160px;
    height: 160px;
  }
  .header-phone{
    display: none;
  }
  .title-bg{
    position: absolute;
    top: 180px;
    left: calc(50% - 340px);
    width: 680px;
    height: 254px;
    background: url(../assets/title-bg.png);
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    font-size: 120px;
    font-family: titleFont;
    padding-top: 20px;
    text-shadow: 4px 4px 8px rgba(255, 255, 255, 1);
  }
  .title-text{
    font-size: 100px;
    font-family: titleFont;
    position: absolute;
    top: 220px;
    left: calc(50% - 640px);
  }
  .content{
    position: absolute;
    padding: 36px;
    top: 560px;
    left: calc(50% - 600px);
    width: 1200px;
    height: 680px;
    background: url(../assets/content-bg.png);
    background-size: 100% 100%;
    font-size: 30px;
    .content-wrapper{
      max-height: 660px;
      overflow: auto;
      p{
        margin-bottom: 20px;
      }
    }
  }
}
@media screen and (max-width: 1600px) {
  .header-content{
    .title-bg{
      top: 120px;
    }
    .content{
      top: 400px;
    }
  }
}
@media screen and (max-width: 768px) {
  .header-content{
    .header-img{
      display: none;
    }
    .header-phone{
      display: block;
      width: 100%;
      height: 870px;
    }
    .logo{
      top: 20px;
      left: 20px;
      width: 120px;
      height: 120px;
    }
    .title-bg{
      top: 10px;
      left: calc(50% - 170px);
      width: 340px;
      height: 127px;
      font-size: 70px;
      padding-top: 0;
    }
    .title-text{
      font-size: 30px;
      font-family: titleFont;
      position: absolute;
      top: 36px;
      left: calc(50% - 170px);
    }
    .content{
      top: 320px;
      padding: 36px;
      left: calc(50% - 278px);
      width: 556px;
      height: 430px;
      max-height: 430px;
      overflow: auto;
      background: url(../assets/content-phone-bg.png);
      background-size: 100% 100%;
      .content-wrapper{
        max-height: 420px;
        overflow: auto;
      }
    }
  }
}
</style>